export default function hintOffer(el) {
	let timer = null;

	return {
		reset() {
			el.classList.add('hidden');
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => el.classList.remove('hidden'), 90000);
		},

		stop() {
			el.classList.add('hidden');
			if (timer) clearTimeout(timer);
			timer = null;
		}
	}
}